import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { AllValues } from '@/utils/types/types.util';
import { CorePermissions } from '@/constants/permissions.constant';
import { loadCorePermissionsFromStorage } from '@/utils/storage/permissions.storage';

type CorePermissionValue = AllValues<typeof CorePermissions>;
type CorePermissionsStore = {
  corePermissions: CorePermissionValue[];
  setCorePermissions: (permissions: CorePermissionValue[]) => void;
};
const useCorePermissionsStore = create(
  devtools<CorePermissionsStore>((set) => ({
    corePermissions: loadCorePermissionsFromStorage(),
    setCorePermissions: (corePermissions) => {
      set({ corePermissions });
    },
  })),
);

export { useCorePermissionsStore };
